import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { AppToggleButtonComponent } from './toggle-button.component';

@NgModule({
    imports: [CommonModule, FormsModule, MatButtonModule],
    declarations: [AppToggleButtonComponent],
    exports: [AppToggleButtonComponent],
})
export class UiToggleButtonModule {}

